// SCROLL TRIGGER
function coScrollTriggerAnimation1(coMarker, coTarget, coTrigger, coYPercent, coXPercent, coScale, coYPercentMob, coXPercentMob, coScaleMob, coStart, coEnd) {
  let target = document.querySelectorAll(coTarget);
  let trigger = document.querySelectorAll(coTrigger);
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function() {
      gsap.to(target, {
          scrollTrigger: {
          trigger: trigger,
          start: coStart,
          end: coEnd,
          markers: coMarker,
          scrub: true
        },
        yPercent: coYPercent,
        xPercent: coXPercent,
        scale: coScale
      });
    }
  });
  ScrollTrigger.matchMedia({
    "(max-width: 767px)": function() {
      gsap.to(target, {
          scrollTrigger: {
          trigger: trigger,
          start: coStart,
          end: coEnd,
          markers: coMarker,
          scrub: true
        },
        yPercent: coYPercentMob,
        xPercent: coXPercentMob,
        scale: coScaleMob
      });
    }
  });
};
// HOMEPAGE
coScrollTriggerAnimation1(
  false,
  ".co---home---hero---right---img", 
  ".co---home---hero", 
  25, 0, 1.1, 
  25, 0, 1.1, 
  "top top", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co---home---section-two---left---img", 
  ".co---home---section-two", 
  -10, 0, 1, 
  0, 0, 1.2, 
  "top bottom", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co---home---section-four---right---img", 
  ".co---home---section-four", 
  0, 0, 1.1, 
  0, 0, 1.2, 
  "top bottom", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co---home---footer-top---img", 
  ".co---home---footer-top", 
  -10, 0, 1.1, 
  0, 0, 1.2,
  "top bottom", 
  "bottom top"
);
// ABOUT
coScrollTriggerAnimation1(
  false,
  ".co--about--section-one--content--img-1", 
  ".co--about--section-one--content", 
  -20, 0, 1, 
  -10, 0, 1, 
  "top top", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co--about--section-one--content--img-2", 
  ".co--about--section-one--content", 
  -5, 0, 1, 
  10, 0, 1, 
  "top top", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co--about--section-one--content--img-3", 
  ".co--about--section-one--content", 
  45, 0, 1, 
  0, 0, 1, 
  "top top", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co--about--section-two--content--img-img", 
  ".co--about--section-two", 
  5, 0, 1.1, 
  0, 0, 1.2, 
  "top bottom", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co--about--section-three--image--img", 
  ".co--about--section-three", 
  10, 0, 1.2, 
  0, 0, 1.2, 
  "top bottom", 
  "bottom top"
);
// LOUNGE
coScrollTriggerAnimation1(
  false,
  ".co--lounge--section-one--image-img", 
  ".co--lounge--section-one", 
  -10, 0, 1, 
  -10, 0, 1, 
  "top top", 
  "bottom top"
);
// BLOG
coScrollTriggerAnimation1(
  false,
  ".co--blog--ginger--content--img-img", 
  ".co--blog--ginger", 
  -10, 0, 1, 
  0, 0, 1.2, 
  "top top", 
  "bottom top"
);
// FAQ
coScrollTriggerAnimation1(
  false,
  ".co--faq-hero--image-img", 
  ".co--faq-hero", 
  -10, 0, 1, 
  -5, 0, 1.1, 
  "top top", 
  "bottom top"
);